export const SPACE_KEY = " ";
export const TAB_KEY = "Tab";
export const ESCAPE_KEY = "Escape";
export const ENTER_KEY = "Enter";
export const SHIFT_KEY = "Shift";
